// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__J74lf","selected":"Chip_selected__3zyGE"};